/** Route URLs */
export const APP_ROUTE = "/";
export const APP_ROUTE_LOGIN = "/login";
export const APP_ROUTE_LOGIN_LOCAL = "/login/local";
export const APP_ROUTE_FORGOT_PASSWORD = "/forgot-password";
export const APP_ROUTE_RESET_PASSWORD = "/reset-password/:token";
export const APP_ROUTE_SET_PASSWORD = "/set-password/:token";
export const APP_ROUTE_OTP = "/login/otp";
export const APP_ROUTE_SIGN_UP = "/sign-up";
export const APP_ROUTE_VERIFY_EMAIL = "/sign-up/verify-email";

export const APP_ROUTE_LIST = "/list";
export const APP_ROUTE_ADD = "/add";
export const CUSTOM_EDIT ="/edit";
export const APP_ROUTE_EDIT = "/:id";
export const MILSESTONE_ROUTE_EDIT = "/:mid";
export const MILESTONE_OBJECT_ID = "/:oid";

export const APP_ROUTE_DASHBOARD = "/dashboard";

export const APP_ROUTE_PROFILE = "/profile";

export const APP_ROUTE_PREFERENCES = "/preferences";

export const APP_ROUTE_USERS = "/users";
export const APP_ROUTE_USERS_LIST = `${APP_ROUTE_USERS}${APP_ROUTE_LIST}`;
export const APP_ROUTE_USERS_ADD = `${APP_ROUTE_USERS}${APP_ROUTE_ADD}`;
export const APP_ROUTE_USERS_EDIT = `${APP_ROUTE_USERS}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_ENTERPRISES = "/enterprises";
export const APP_ROUTE_ENTERPRISES_LIST = `${APP_ROUTE_ENTERPRISES}${APP_ROUTE_LIST}`;
export const APP_ROUTE_ENTERPRISES_ADD = `${APP_ROUTE_ENTERPRISES}${APP_ROUTE_ADD}`;
export const APP_ROUTE_ENTERPRISES_EDIT = `${APP_ROUTE_ENTERPRISES}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_LEARNING_DASHBOARD = "/my-dashboard";
export const APP_ROUTE_LEARNING_JOURNEY = "/learning-journey";
export const APP_ROUTE_MY_TEAM = "/my-team";
export const APP_ROUTE_MY_TEAM_REPORTS = `${APP_ROUTE_MY_TEAM}/reports`;

export const APP_ROUTE_LEARNING_JOURNEY_PROGRAMS = `${APP_ROUTE_LEARNING_JOURNEY}/programs`;
export const APP_ROUTE_LEARNING_JOURNEY_PROGRAMS_MILESTONES = `${APP_ROUTE_LEARNING_JOURNEY_PROGRAMS}${APP_ROUTE_EDIT}/milestones`;
export const APP_ROUTE_LEARNING_JOURNEY_PROGRAMS_MILESTONE_DETAILS = `${APP_ROUTE_LEARNING_JOURNEY_PROGRAMS}${APP_ROUTE_EDIT}/milestones${MILSESTONE_ROUTE_EDIT}/object${MILESTONE_OBJECT_ID}`;

export const APP_ROUTE_ENTERPRISE = "/enterprise";

export const APP_ROUTE_ADMINISTRATION = "/administration";
export const APP_ROUTE_ADMINISTRATION_USERS = `${APP_ROUTE_ADMINISTRATION}/users`;
export const APP_ROUTE_ADMINISTRATION_USERS_LIST = `${APP_ROUTE_ADMINISTRATION_USERS}${APP_ROUTE_LIST}`;
export const APP_ROUTE_ADMINISTRATION_USERS_ADD = `${APP_ROUTE_ADMINISTRATION_USERS}${APP_ROUTE_ADD}`;
export const APP_ROUTE_ADMINISTRATION_USERS_EDIT = `${APP_ROUTE_ADMINISTRATION_USERS}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_ADMINISTRATION_ROLES = `${APP_ROUTE_ADMINISTRATION}/roles`;
export const APP_ROUTE_ADMINISTRATION_ROLES_LIST = `${APP_ROUTE_ADMINISTRATION_ROLES}${APP_ROUTE_LIST}`;
export const APP_ROUTE_ADMINISTRATION_ROLES_ADD = `${APP_ROUTE_ADMINISTRATION_ROLES}${APP_ROUTE_ADD}`;
export const APP_ROUTE_ADMINISTRATION_ROLES_EDIT = `${APP_ROUTE_ADMINISTRATION_ROLES}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_ADMINISTRATION_CUSTOM_FIELDS = `/custom-fields`;
export const APP_ROUTE_ADMINISTRATION_CUSTOM_FIELDS_LIST = `${APP_ROUTE_ADMINISTRATION_CUSTOM_FIELDS}${APP_ROUTE_LIST}`;

export const APP_ROUTE_ADMINISTRATION_CUSTOM_FIELD_SECTIONS = `/custom-fields/sections`;
export const APP_ROUTE_ADMINISTRATION_CUSTOM_FIELD_SECTIONS_ADD = `${APP_ROUTE_ADMINISTRATION_CUSTOM_FIELD_SECTIONS}${APP_ROUTE_ADD}`;
export const APP_ROUTE_ADMINISTRATION_CUSTOM_FIELD_SECTIONS_EDIT = `${APP_ROUTE_ADMINISTRATION_CUSTOM_FIELD_SECTIONS}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_ADMINISTRATION_AUDIENCES = `/audiences`;
export const APP_ROUTE_ADMINISTRATION_AUDIENCES_LIST = `${APP_ROUTE_ADMINISTRATION_AUDIENCES}${APP_ROUTE_LIST}`;
export const APP_ROUTE_ADMINISTRATION_AUDIENCES_ADD = `${APP_ROUTE_ADMINISTRATION_AUDIENCES}${APP_ROUTE_ADD}`;
export const APP_ROUTE_ADMINISTRATION_AUDIENCES_EDIT = `${APP_ROUTE_ADMINISTRATION_AUDIENCES}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_CONTENTS = "/learning";

export const APP_ROUTE_CONTENTS_LEARNING_OBJECTS = `${APP_ROUTE_CONTENTS}/objects`;
export const APP_ROUTE_CONTENTS_LEARNING_OBJECTS_LIST = `${APP_ROUTE_CONTENTS_LEARNING_OBJECTS}${APP_ROUTE_LIST}`;
export const APP_ROUTE_CONTENTS_LEARNING_OBJECTS_ADD = `${APP_ROUTE_CONTENTS_LEARNING_OBJECTS}${APP_ROUTE_ADD}`;
export const APP_ROUTE_CONTENTS_LEARNING_OBJECTS_EDIT = `${APP_ROUTE_CONTENTS_LEARNING_OBJECTS}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_CONTENTS_LEARNING_MILESTONES = `${APP_ROUTE_CONTENTS}/milestones`;
export const APP_ROUTE_CONTENTS_LEARNING_MILESTONES_LIST = `${APP_ROUTE_CONTENTS_LEARNING_MILESTONES}${APP_ROUTE_LIST}`;
export const APP_ROUTE_CONTENTS_LEARNING_MILESTONES_ADD = `${APP_ROUTE_CONTENTS_LEARNING_MILESTONES}${APP_ROUTE_ADD}`;
export const APP_ROUTE_CONTENTS_LEARNING_MILESTONES_EDIT = `${APP_ROUTE_CONTENTS_LEARNING_MILESTONES}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_CONTENTS_LEARNING_PATHS = `${APP_ROUTE_CONTENTS}/programs`;
export const APP_ROUTE_CONTENTS_LEARNING_PATHS_LIST = `${APP_ROUTE_CONTENTS_LEARNING_PATHS}${APP_ROUTE_LIST}`;
export const APP_ROUTE_CONTENTS_LEARNING_PATHS_ADD = `${APP_ROUTE_CONTENTS_LEARNING_PATHS}${APP_ROUTE_ADD}`;
export const APP_ROUTE_CONTENTS_LEARNING_PATHS_EDIT = `${APP_ROUTE_CONTENTS_LEARNING_PATHS}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_REPORTS = "/reports";
export const APP_ROUTE_REPORTS_LIST = `${APP_ROUTE_REPORTS}${APP_ROUTE_LIST}`;

export const APP_ROUTE_NOTIFICATIONS = "/notifications";

export const APP_ROUTE_NOTIFICATIONS_BUILDER = `${APP_ROUTE_NOTIFICATIONS}/builder`;
export const APP_ROUTE_NOTIFICATIONS_BUILDER_LIST = `${APP_ROUTE_NOTIFICATIONS_BUILDER}${APP_ROUTE_LIST}`;
export const APP_ROUTE_NOTIFICATIONS_BUILDER_ADD = `${APP_ROUTE_NOTIFICATIONS_BUILDER}${APP_ROUTE_ADD}`;
export const APP_ROUTE_NOTIFICATIONS_BUILDER_CUSTOM_EDIT = `${APP_ROUTE_NOTIFICATIONS_BUILDER}${CUSTOM_EDIT}`;

export const APP_ROUTE_NOTIFICATIONS_LOGS = `${APP_ROUTE_NOTIFICATIONS}/logs`;
export const APP_ROUTE_NOTIFICATIONS_LOGS_LIST = `${APP_ROUTE_NOTIFICATIONS_LOGS}${APP_ROUTE_LIST}`;

export const APP_ROUTE_WORKFLOWS = "/workflows";
export const APP_ROUTE_WORKFLOWS_LIST = `${APP_ROUTE_WORKFLOWS}${APP_ROUTE_LIST}`;

export const APP_ROUTE_ASSIGNMENTS = "/assignments";
export const APP_ROUTE_ASSIGNMENTS_LIST = `${APP_ROUTE_ASSIGNMENTS}${APP_ROUTE_LIST}`;
export const APP_ROUTE_ASSIGNMENTS_LEARNING_PATHS = `${APP_ROUTE_ASSIGNMENTS}/learning-programs/:id`;
export const APP_ROUTE_ASSIGNMENTS_AUDIENCE = `${APP_ROUTE_ASSIGNMENTS}/audiences/:id`;

export const APP_ROUTE_CERTIFICATES = "/certificates";
export const APP_ROUTE_CERTIFICATES_LIST = `${APP_ROUTE_CERTIFICATES}${APP_ROUTE_LIST}`;
export const APP_ROUTE_CERTIFICATES_ADD = `${APP_ROUTE_CERTIFICATES}${APP_ROUTE_ADD}`;

export const APP_ROUTE_REWARDS = "/rewards";
export const APP_ROUTE_REWARDS_LIST = `${APP_ROUTE_REWARDS}${APP_ROUTE_LIST}`;
export const APP_ROUTE_REWARDS_ADD = `${APP_ROUTE_REWARDS}${APP_ROUTE_ADD}`;
export const APP_ROUTE_REWARDS_EDIT = `${APP_ROUTE_REWARDS}${APP_ROUTE_EDIT}`;

export const APP_ROUTE_INTEGRATIONS = "/integrations";
export const APP_ROUTE_INTEGRATIONS_LIST = `${APP_ROUTE_INTEGRATIONS}${APP_ROUTE_LIST}`;
export const APP_ROUTE_INTEGRATIONS_ADD = `${APP_ROUTE_INTEGRATIONS}${APP_ROUTE_ADD}`;
export const APP_ROUTE_INTEGRATIONS_EDIT = `${APP_ROUTE_INTEGRATIONS}${APP_ROUTE_EDIT}`;
